import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'

import { actionCreators } from 'reduxBits/config'

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})

export class _Configuration extends React.Component {
  componentDidMount() {
    this.props.actions.fetchConfiguration()
  }

  render() {
    return null
  }
}

_Configuration.propTypes = {
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
}

export default connect(
  undefined,
  mapDispatchToProps,
)(_Configuration)
